/**
 * CustomEvent() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
 */
(function () {

    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

// Page Pre-Loading
$(document).ready(function() {
    removePreloader = setTimeout(removePreloader, 300);
});
$(window).on("load", function() {
    removePreloader = setTimeout(removePreloader, 10);
});

// Create Event
var event = new CustomEvent('preloaded');

function removePreloader() {
    clearTimeout(removePreloader);



    // Remove Pre-Loaded Styles
    var preloader = document.getElementById("preloading");
    if (preloader) {
        preloader.parentNode.removeChild(preloader);
    }
    var loadingspinner = document.getElementById("loadingspinner");
    if (loadingspinner) {
        loadingspinner.parentNode.removeChild(loadingspinner);
    }

    // Trigger Event
    document.dispatchEvent(event);
}